<script>
  import { onMount } from "svelte";
  import Header from "../components/Header.svelte";
  import { writable } from "svelte/store";
  import { get } from "svelte/store";

  let videos = writable([]);
  let topTags = [];

  onMount(async () => {
    loadTopTags();
  });

  async function loadTopTags() {
    try {
      const response = await fetch(
        `https://api.trulens.ae/api/videos/top-tags?_=${Date.now()}`
      );
      const data = await response.json();
      topTags = data;
    } catch (error) {
      console.error("Failed to load top tags:", error);
    }
  }

  async function handleTagClick(tag) {
    try {
      const response = await fetch(
        `https://api.trulens.ae/api/videos/tags-search?tags=${encodeURIComponent(tag)}&_=${Date.now()}`
      );
      const data = await response.json();
      if (response.ok) {
        localStorage.setItem("storedVideos", JSON.stringify(data));
        window.location.href = "#/tags";
        window.location.reload();
      } else {
        console.error("Error fetching search results:", data.error);
      }
    } catch (error) {
      console.error("Failed to load videos by tag:", error);
    }
  }

  onMount(async () => {
    let storedVideos = JSON.parse(localStorage.getItem("storedVideos"));

    if (!storedVideos) {
      const response = await fetch("https://api.trulens.ae/api/videos/all");
      const data = await response.json();
      videos.set(data);
      localStorage.setItem("storedVideos", JSON.stringify(data));
    } else {
      videos.set(storedVideos);
    }

    videos.update((videos) => {
      return videos
        .map((video) => {
          if (
            video.mimeType.startsWith("image/") ||
            video.mimeType.startsWith("video/")
          ) {
            return { ...video };
          }
          return null; // Filter out videos with other MIME types
        })
        .filter((video) => video !== null);
    });
  });

  function playVideo(videoId) {
    window.location.href = `#/video/${videoId}`;
  }

  function handleVideoClick(video) {
    playVideo(video._id);
  }

  function nameTimestamp(timestamp) {
    const cleanTimestamp = timestamp
      .replace(/\.(mkv|jpg)/, "")
      .replace(/_/g, ":");
    return formatTimestamp(cleanTimestamp);
  }

  function formatTimestamp(timestamp) {
    const date = new Date(timestamp);

    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const dayName = days[date.getDay()];
    const day = date.getDate();
    const ordinalSuffix = (n) => {
      const s = ["th", "st", "nd", "rd"];
      const v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    };
    const monthName = months[date.getMonth()];
    const year = String(date.getFullYear()).slice(-2);

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;

    return `${dayName}, ${ordinalSuffix(day)} ${monthName} ${year} ${hours}:${minutes} ${ampm}`;
  }
</script>

<link
  href="https://unpkg.com/maplibre-gl/dist/maplibre-gl.css"
  rel="stylesheet"
/>

<link
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"
  rel="stylesheet"
/>

<Header />
<div class="title">
  <span class="title-span">
    <div class="tags-list">
      {#each topTags as { tag, count }}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div class="tag-item" on:click={() => handleTagClick(tag)}>
          <span class="tag-name">{tag}</span>
          <!-- <span class="tag-count">({count})</span> -->
        </div>
      {/each}
    </div>
  </span>
</div>

{#if $videos.length === 0}
  <p class="no-videos">No posts found.</p>
{:else}
  <div class="video-container">
    {#each $videos as video}
      <div
        class="video-wrapper"
        on:click={() => handleVideoClick(video)}
        role="button"
        tabindex="0"
        on:keydown={(e) => e.key === "Enter" && handleVideoClick(video)}
      >
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div
          class="video-card"
          on:click={() => handleVideoClick(video)}
          role="button"
          tabindex="0"
          on:keydown={(e) => e.key === "Enter" && handleVideoClick(video)}
        >
          {#if video.mimeType.startsWith("video/")}
            <!-- svelte-ignore a11y-media-has-caption -->
            <video src={video.downloadURL} controls />
          {:else if video.mimeType.startsWith("image/")}
            <img src={video.downloadURL} alt={video.title} />
          {/if}
        </div>
        <div class="bottom-content">
          <span class="user-info">
            {#if video.isNamePrivate}
              <!-- Profile Picture and User Name -->
              <div class="profile-info">
                <img
                  class="profile-picture"
                  src="/anonymous.jpg"
                  alt="Profile Picture"
                />
                <span style="font-weight: bold;">{video.alternateName}</span>
                &nbsp;
                <i class="fa-solid fa-user-lock" style="font-size: small;"></i>
              </div>
            {:else}
              <!-- Profile Picture and User Name -->
              <div class="profile-info">
                <img
                  class="profile-picture"
                  src={video.userId.profilePicture || "/profile.png"}
                  alt="Profile Picture"
                />
                <span style="font-weight: bold;">{video.userId.name}</span>
              </div>
            {/if}
          </span>
          <span class="video-title">{video.title}</span>
          <div class="time-info">
            <span>{nameTimestamp(video.originalName)}</span>
          </div>
        </div>
      </div>
    {/each}
  </div>
{/if}

<style>
  .profile-info {
    display: flex;
    align-items: center;
  }

  .profile-picture {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-right: 10px;
  }

  .content {
    position: relative;
    min-height: 100vh;
  }

  .top-tags {
    padding: 20px;
    background: #f4f4f4;
    box-shadow: 0 4px 8px rgba(135, 135, 135, 0.1);
    margin-bottom: 20px;
  }

  .top-tags h2 {
    text-align: center;
    margin-bottom: 10px;
  }

  .tags-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .tag-item {
    margin: 5px 10px;
    padding: 5px 5px;
    background: #ddd;
    border: 1px solid #e0e0e0;
    border-radius: 5px;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
  }

  .tag-name {
    cursor: pointer;
    font-weight: bold;
  }

  .tag-count {
    font-size: 0.8rem;
    color: #666;
  }

  .title {
    position: relative;
    display: flex;
    justify-content: center;
    padding: 5px;
    box-shadow: 0 4px 8px rgba(135, 135, 135, 0.1);
  }

  .title-span {
    margin-top: 5px;
    border-radius: 25%;
    padding: 5px;
    font-size: 1.4rem;
    font-weight: bold;
    color: #000000;
  }

  .video-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 50px;
    max-width: 2000px; /* Set a maximum width */
    margin: 0 auto; /* Center the container */
    position: relative;
  }

  .video-wrapper {
    width: 100%; /* Full width on small screens */
    margin: 10px;
    text-align: left;
  }

  .video-card {
    position: relative;
    height: 350px;
    overflow: hidden;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    cursor: pointer;
  }

  .video-card video,
  .video-card img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    background-color: #000;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .bottom-content {
    padding: 10px;
    background: #f9f9f9;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    cursor: pointer;
  }

  .video-title {
    /* font-weight: bold; */
    color: #000000;
    margin-top: 10px;
  }

  .rotate-90 {
    transform: rotate(90deg);
  }

  .user-info {
    font-size: 0.9rem;
    color: #000000;
  }

  .tags-info {
    font-size: 0.6rem;
    color: #515151;
  }

  .time-info {
    font-size: 0.6rem;
    color: #515151;
  }

  .spinner {
    position: absolute;
    bottom: 10px; /* Adjust bottom margin as needed */
    left: 48%;
    transform: translateX(-50%);
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 5px solid rgba(0, 0, 0, 0.1);
    border-top-color: #3498db;
    animation: spin 1s ease-in-out infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  /* @media only screen and (width: 820px) {
    .title {
      margin-top: 50px;
    }
  }

  @media only screen and (width: 1024px) {
    .title {
      margin-top: 60px;
    }
  }

  @media only screen and (width: 1978px) {
    .title {
      margin-top: 60px;
    }
  }

  @media only screen and (width: 540px) {
    .title {
      margin-top: 5px;
    }
  } */

  @media (max-width: 767px) {
    .title {
      padding: 10px 20px;
    }

    .title-span {
      font-size: 1.2rem;
    }

    .video-container {
      padding: 20px;
    }

    .video-wrapper {
      width: 100%;
      margin: 10px 0;
      text-align: left;
    }

    .video-card {
      height: 65vh;
    }

    .bottom-content {
      padding: 10px;
      background: #f9f9f9;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      cursor: pointer;
    }

    .spinner {
      position: absolute;
      bottom: 10px;
      left: 46%;
      transform: translateX(-50%);
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 5px solid rgba(0, 0, 0, 0.1);
      border-top-color: #3498db;
      animation: spin 1s ease-in-out infinite;
    }

    .tag-item {
      margin: 2px 2px;
      padding: 2px 2px;
      background: #ddd;
      border: 1px solid #e0e0e0;
      font-size: 0.4rem;
    }

    .tag-name {
      font-weight: bold;
    }
  }

  @media screen and (min-width: 768px) {
    .video-wrapper {
      width: 24.5%;
    }

    .video-card {
      height: 350px;
    }

    .title {
      margin-top: 40px;
    }
  }

  @media screen and (min-width: 850px) {
    .title {
      margin-top: 5px;
    }
  }

  @media screen and (min-width: 850px) and (min-height: 1280px) {
    .title {
      margin-top: 55px;
    }
  }

  @media screen and (min-width: 1024px) and (max-width: 1024px) and (max-height: 600px) {
    .video-wrapper {
      width: 20%;
    }

    .video-card {
      height: 350px;
    }

    .title {
      margin-top: 5px;
    }
  }

  @media screen and (min-width: 1024px) and (min-height: 1300px) {
    .video-wrapper {
      width: 20%;
    }

    .video-card {
      height: 350px;
    }

    .title {
      margin-top: 60px;
    }
  }

  @media screen and (min-width: 1440px) {
    .video-wrapper {
      width: 35%; /* More videos per row on very large screens */
    }

    .video-card {
      height: 450px;
    }

    .title {
      margin-top: 20px;
    }
  }
</style>
